import { type dash_growth } from "@dropbox/api-v2-client";
import { APIv2Callable } from "@mirage/service-dbx-api/service";
import Sentry from "@mirage/shared/sentry";
import { ConsolaInstance } from "consola";

export type DashTrialInfo = {
  days_remaining: number;
  trial_activated: boolean;
  admin_name?: string;
  admin_email?: string;
  trial_name?: string;
  display_dash_trial_indicator: boolean;
};
function determineIfShouldDisplayDashTrialIndicator(
  daysRemaining: number,
  trial_activated: boolean,
): boolean {
  return daysRemaining >= 0 && trial_activated;
}

export async function fetchDashTrialInfoFromApi(
  callApiV2: APIv2Callable,
  logger: ConsolaInstance,
): Promise<DashTrialInfo | undefined> {
  try {
    const response = await callApiV2("dashGrowthGetDashTrialInfo", {});
    return mapDashTrialInfo(response);
  } catch (error) {
    logger.error(
      `getDashTrialInfo - Failed to fetch dash trial info: ${error}`,
    );
    Sentry.captureException(error);
    return undefined;
  }
}

export function mapDashTrialInfo(
  response: dash_growth.DashTrialGetInfoResponse,
): DashTrialInfo {
  const daysRemaining = response.days_remaining ?? 0;
  const trialActivated = response.trial_activated ?? false;
  const trialName = response.trial_name ? response.trial_name : "Dash";
  return {
    days_remaining: daysRemaining,
    trial_activated: trialActivated,
    admin_name: response.admin_name ?? "",
    admin_email: response.admin_email ?? "",
    trial_name: trialName,
    display_dash_trial_indicator: determineIfShouldDisplayDashTrialIndicator(
      daysRemaining,
      trialActivated,
    ),
  };
}

export function getTodaysDateString(): string {
  return new Date().toISOString().split("T")[0];
}
